module.exports = __webpack_public_path__ + "img/abstract.7bd1f759.svg";